export default class ClashModel
{
    constructor(constructionelement, installationelement, clashmesh, clashid, parameters)
    {
        this.constructionelement = constructionelement;
        this.installationelement = installationelement;  
        this.mesh = clashmesh;
        this.meshuuid = clashid;
        this.parameters = parameters;
        this.isclash = true;

    }
    
}